module.exports = __webpack_public_path__ + "img/Noctiluca-Process-1.ab266e76.png";